
import { Note } from "../../../models/note.model.ts";
import { NoteSerializer } from "../../../models/serializers/noteSerializer.ts";
import { httpRequest } from "../../http";

export class CommandFetchNotes {
    async run(notebookId: number, parentId: number | null) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}/pages/?parent=${parentId}`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Note []{
        const serializer = new NoteSerializer();
        return serializer.deserializeList(data);
    }

    SingleDeserialize(data: any) : Note{
        const serializer = new NoteSerializer();
        return serializer.deserialize(data);
    }
}

